import { Entry } from '../Entry'

export function Entry20240711() {
  return (
    <Entry title="11/07/2024 - v3.7.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15969/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
